/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAssignToMe = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M10 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM5 7a5 5 0 1 1 10 0A5 5 0 0 1 5 7zm13.414 6 1.293 1.293-1.414 1.414L14.586 12l3.707-3.707 1.414 1.414L18.414 11H22v2zM5.32 17.476C4.436 18.328 4 19.541 4 21v1H2v-1c0-1.857.564-3.644 1.93-4.963C5.296 14.72 7.327 14 10 14c2.674 0 4.705.72 6.07 2.037C17.435 17.356 18 19.143 18 21v1h-2v-1c0-1.459-.436-2.672-1.32-3.524C13.796 16.622 12.327 16 10 16c-2.326 0-3.795.622-4.68 1.476z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgAssignToMe as AssignToMe };
